<script lang="ts">
    import lang from "@common/services/lang"
</script>

<h1>404</h1>
<p>{window.location.pathname} {lang('is-unknown')}</p>